export default state => state?.trolley?.loaded ?? false;
